import { IUserInfo } from "common/interfaces/IUserInfo";

export const loginUser = async (credentials: {
  email: string;
  password: string;
}): Promise<any> => {
  return fetch(`${process.env.REACT_APP_BASE_URL}/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  }).then(async (data) => {
    const authData = await data.json();
    if (authData?.access_token) {
      localStorage.setItem("auth:userId", authData?.userId);
      localStorage.setItem("auth:token", authData?.access_token);
    }
    return authData;
  });
};

export const registerUser = async (credentials: IUserInfo): Promise<any> => {
  return fetch(`${process.env.REACT_APP_BASE_URL}/auth/register`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  }).then((data) => data.json());
};
